export const state = {
  mail: {
    mailHistoryId: 0,
    type: 0,
    title: '',
    message: '',
    startDateTime: 0,
    endDateTime: 0,
    userId: '',
    mailAddress: '',
    total: 0,
    success: 0,
    failure: 0
  },
  mailHistories: [],
  total: 0,
  selectMailHistoryId: null,
  searchStartDateTime: '',
  searchEndDateTime: ''
}
export const mutations = {
  setMailHistories(state, response) {
    if (response.data['data'] == null) {
      response.data['data'] = [{}]
      state.total = 0
    }

    state.mailHistories = response.data['data']
    state.total = response.data['header']['total']
  },
  setMailHistoriesDetail(state, response) {
    if (response.data['data'] == null) {
      response.data['data'] = {}
    }
    state.mail = response.data['data']
  },
  setSelectMailHistoryId(state, payload) {
    state.selectMailHistoryId = payload
  },
  setSearchStartDateTime(state, payload) {
    state.searchStartDateTime = payload
  },
  setSearchEndDateTime(state, payload) {
    state.searchEndDateTime = payload
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/mailHistoryModules/mailHistoryMutation.js